import bowser from 'yola-bowser';
import { isTag, isElementNode } from 'anodum';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import findRootEditableElement from './find-root-editable-element';
import findFirstTextNode from './find-first-text-node';
import { LIST_ITEM } from '../constants/editable-elements';
import unwrapElement from './unwrap-element';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import operations from '../operations';
import isBreakElement from '../verifiers/is-break-element';

const handleBackspaceOnListItemBeginning = (e) => {
  const [node, offset] = getCollapsedNodeAndOffset();
  const editableElement = findRootEditableElement(node);

  if (!editableElement || !isTag(editableElement, LIST_ITEM)) return false;

  const firstTextNode = findFirstTextNode(editableElement, true);

  if (
    (firstTextNode &&
      firstTextNode !== node &&
      !(bowser.firefox && isElementNode(node) && !isBreakElement(node))) ||
    offset !== 0
  ) {
    return false;
  }

  operations.addCheckpoint();
  e.preventDefault();
  let { parentNode: listElement } = editableElement;
  const childrenArray = Array.from(listElement.children);
  let lastIndex = childrenArray.length - 1;
  let currentListItemIndex = childrenArray.indexOf(editableElement);

  if (currentListItemIndex > 0 && currentListItemIndex < childrenArray.length - 1) {
    const { ownerDocument: liveDocument } = e.srcElement;
    const newList = liveDocument.createElement(listElement.tagName);
    const newListChildren = childrenArray.slice(currentListItemIndex);
    newList.append(...newListChildren);
    listElement.insertAdjacentElement('afterend', newList);
    currentListItemIndex = newListChildren.indexOf(editableElement);
    listElement = newList;
    lastIndex = newList.length - 1;
  }

  switch (currentListItemIndex) {
    case 0:
      listElement.insertAdjacentElement('beforebegin', editableElement);
      break;
    case lastIndex:
      listElement.insertAdjacentElement('afterend', editableElement);
      break;
  }

  if (!listElement.children.length) {
    listElement.remove();
  }

  unwrapElement(editableElement);
  setCaretAtTheBeginningOfNode(node);

  return true;
};

export default handleBackspaceOnListItemBeginning;
